namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeForm {
        DiscCouponType: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
        StartDate: Serenity.DateEditor;
        EndDate: Serenity.DateEditor;
        DiscCouponName: Serenity.StringEditor;
        DiscCouponValueType: Serenity.EnumEditor;
        DiscCouponValue: Serenity.DecimalEditor;
        PartnerCompensatePc: Serenity.DecimalEditor;
        ProdImageLink: Serenity.ImageUploadEditor;
    }

    export class PsDiscCouponTypeForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsDiscCouponType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsDiscCouponTypeForm.init)  {
                PsDiscCouponTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.DateEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.ImageUploadEditor;

                Q.initFormType(PsDiscCouponTypeForm, [
                    'DiscCouponType', w0,
                    'IsActive', w1,
                    'StartDate', w2,
                    'EndDate', w2,
                    'DiscCouponName', w0,
                    'DiscCouponValueType', w3,
                    'DiscCouponValue', w4,
                    'PartnerCompensatePc', w4,
                    'ProdImageLink', w5
                ]);
            }
        }
    }
}
